import React from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';
import { TopFooter } from 'ui/components/panes/Footer/TopFooter';
import { TERMS_OF_SERVICE_FOR_SUPPORTER } from 'domain/valueObjects/Terms/Terms';

const Container = styled.div`
    width: 87.674%;
    max-width: 1400px;
    margin: 60px auto;
    color: #333;
    line-height: 1.8;

    ${mqMin('NARROW')} {
        width: 92.014%;
    }
`;

const Title = styled.h2`
    font-size: 1.875rem;
    font-weight: bold;
    margin-bottom: 40px;
    border-left: 5px solid var(--blue);
    padding-left: 15px;
`;

const Section = styled.div`
    margin-bottom: 40px;
`;

const SubHeading = styled.h3`
    font-size: 1.25rem;
    margin-top: 30px;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Paragraph = styled.p`
    margin: 10px 0;
`;

export const TermsOfServiceForSupporter = () => {
    return (
        <>
            <TopHeader />
            <Container>
                <Title>{TERMS_OF_SERVICE_FOR_SUPPORTER.title}</Title>
                <Paragraph>
                    本 MAny サポーター利用規約(以下「本規約」といいます。)は、株式会社
                    Sirbe(以下「当社」といいます。)が運営する事業承継支援プラットフォーム「MAny」において認定されるMAny
                    サポーター(第 2 条に定義)の活動に関する条件を定めるものです。
                    <br />
                    MAny
                    サポーターとして登録を希望する方および登録された方(以下総称して「サポーター」といいます。)は、本規約に同意のうえ、本活動に参加するものとします。
                </Paragraph>
                {TERMS_OF_SERVICE_FOR_SUPPORTER.sections.map((section, index) => (
                    <Section key={index}>
                        <SubHeading>{section.heading}</SubHeading>
                        <Paragraph>
                            {section.content.split('\n').map((line, lineIndex) => (
                                <React.Fragment key={lineIndex}>
                                    {line}
                                    {lineIndex < section.content.split('\n').length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </Paragraph>
                    </Section>
                ))}
            </Container>
            <TopFooter />
        </>
    );
};
